/* unplugin-vue-components disabled */import script from "./table-list.vue?vue&type=script&setup=true&lang=ts"
export * from "./table-list.vue?vue&type=script&setup=true&lang=ts"

import "./table-list.vue?vue&type=style&index=0&id=f658ae96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f658ae96"]])

export default __exports__